/* eslint-disable import/prefer-default-export */
export const maskIPAddresses = (input) => {
  const regex =
    /\b(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\b/gi;
  return input.replace(regex, '$1.$2.x.x');
};
